/** The page width constraint, in one place (template §9). */
export default function Container({ className = "", children }) {
  return <div className={`container-xl px-3 px-md-4 ${className}`}>{children}</div>;
}
